const PENDO_ICON_HEIGHT = 56 as const
export const INNER_PAGE_HEIGHT = `calc(100% - ${PENDO_ICON_HEIGHT + 14}px)` as const
export const INNER_PAGE_HEIGHT_WHEADER = `calc(100% - 143px)` as const
